/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Exercise_RequiredInputs */

const en_us2_workout_exercise_required = /** @type {(inputs: Workout_Exercise_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This set has no exercise. Log it again from the exercise.`)
};

const pt_br2_workout_exercise_required = /** @type {(inputs: Workout_Exercise_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta série está sem exercício. Registre de novo a partir do exercício.`)
};

const es_419_workout_exercise_required = /** @type {(inputs: Workout_Exercise_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta serie no tiene ejercicio. Regístrala de nuevo desde el ejercicio.`)
};

const pt_pt2_workout_exercise_required = /** @type {(inputs: Workout_Exercise_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta série não tem exercício. Regista-a de novo a partir do exercício.`)
};

const fr_fr2_workout_exercise_required = /** @type {(inputs: Workout_Exercise_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette série n'a pas d'exercice. Enregistre-la de nouveau depuis l'exercice.`)
};

const de_de2_workout_exercise_required = /** @type {(inputs: Workout_Exercise_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Satz hat keine Übung. Trag ihn erneut über die Übung ein.`)
};

const it_it2_workout_exercise_required = /** @type {(inputs: Workout_Exercise_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questa serie non ha un esercizio. Registrala di nuovo dall'esercizio.`)
};

/**
* | output |
* | --- |
* | "This set has no exercise. Log it again from the exercise." |
*
* @param {Workout_Exercise_RequiredInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_exercise_required = /** @type {((inputs?: Workout_Exercise_RequiredInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Exercise_RequiredInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_exercise_required(inputs)
	if (locale === "es-419") return es_419_workout_exercise_required(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_exercise_required(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_exercise_required(inputs)
	if (locale === "de-DE") return de_de2_workout_exercise_required(inputs)
	if (locale === "it-IT") return it_it2_workout_exercise_required(inputs)
	return en_us2_workout_exercise_required(inputs)
});
export { workout_exercise_required as "workout.exercise_required" }